import * as opportunity from './opportunity';

export enum Roles {
  ADMIN = 'admin',
  VIEWER = 'viewer',
}

export type roleType = `${Roles}`;

export enum VerificationStatus {
  NOT_VERIFIED = 'not-verified',
  PENDING = 'pending',
  UPDATES_REQUIRED = 'updates-required',
  VERIFIED = 'verified',
  SERVICE_DENIED = 'service-denied',
  EXPIRED = 'expired',
}

export type VerificationStatusType = `${VerificationStatus}`;

export interface UserInfo {
  countryCode: string;
  email: string;
  investorType: string;
  fullName: string;
  entityName: string;
  investorId: string;
  verificationStatus: VerificationStatusType;
  accreditationStatus: string;
  suitabilityStatus: string;
  accountStatus: string;
  brokerDealerId?: number;
  language: string;
  reverseSolicitation: boolean;
  role: roleType;
}

export interface BaseMixPanel {
  track: (event: string, data?: any) => void;
}

export interface MixPanel extends BaseMixPanel {
  alias: (investorId: string) => void;
  identify: (uniqueIdentifier: string) => void;
  register: (data?: any) => void;
  getMixpanelId: () => any;
  resetMixPanel: () => void;
  people: {
    set: (params: any) => void;
    set_once: (params: any) => void;
  };
}

export { opportunity };

export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
}

export type CurrencyType = `${Currency}`;

export enum Theme {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
};

export type ThemeType = `${Theme}`;
